import React, { useCallback, useState } from 'react'

import { Button } from '@material-ui/core'
import fileDownload from 'js-file-download'
import PropTypes from 'prop-types'

import api, { getZip } from 'common/api'
import { formatter } from 'common/date'
import BatchFileSelectionModal from 'components/BatchFileSelectionModal'

const DailyBatchesDownloadActionCell = ({ record, onSuccess }) => {
  const [loading, setLoading] = useState(false)
  const dateElem = formatter.format(record.SentDate)
  const [batchFileSelectionModalOpen, setBatchFileSelectionModalOpen] = useState(false)

  const markAsDownloaded = useCallback((scid, batchId, fileId) => {
    return api.post(`/api/colleges/${scid}/batches/${batchId}/files/${fileId}/received`)
  }, [])
  const saveFile = useCallback((fileBlob, fileName) => {
    fileDownload(fileBlob, fileName, 'application/zip')
  }, [])
  const download = useCallback(
    ({ scid, batchId, fileId, fileName }) => {
      return getZip(`/api/colleges/${scid}/batches/${batchId}/files/${fileId}/download`).then((fileBlob) => {
        markAsDownloaded(scid, batchId, fileId).then(() => {
          onSuccess()
        })
        saveFile(fileBlob, fileName)
      })
    },
    [markAsDownloaded, saveFile, onSuccess],
  )

  const handleDownload = () => {
    if (record.Files.length === 0) {
      return
    } else if (record.Files.length === 1) {
      setLoading(true)
      download({
        scid: record.Scid,
        batchId: record.Id,
        fileId: record.Files[0].Id,
        fileName: record.Files[0].Filename,
      }).finally(() => setLoading(false))
    } else {
      setBatchFileSelectionModalOpen(true)
    }
  }

  return (
    <>
      <Button
        onClick={() => handleDownload()}
        disabled={loading}
        color="primary"
        variant={record.SystemState === 'delivered' ? 'outlined' : 'contained'}
        size="small"
        aria-label={`Download batch for ${dateElem}`}
      >
        Batch
      </Button>
      <BatchFileSelectionModal
        title="Download Batch File(s)"
        open={batchFileSelectionModalOpen}
        onCancel={() => setBatchFileSelectionModalOpen(false)}
        files={record.Files}
        onDownload={(fileId, fileName) => {
          return download({ scid: record.Scid, batchId: record.Id, fileId: fileId, fileName: fileName })
        }}
      />
    </>
  )
}

DailyBatchesDownloadActionCell.propTypes = {
  record: PropTypes.object.isRequired,
  onSuccess: PropTypes.func,
}

export default DailyBatchesDownloadActionCell
